export const SET_FUNNELS = 'SET_FUNNELS';
export const SET_AVAILABLE_LABELS = 'SET_AVAILABLE_LABELS';
export const SET_SELECTED_FUNNEL_ID = 'SET_SELECTED_FUNNEL_ID'; // Armazenar ID
export const SET_CARDS_BY_LABEL = 'SET_CARDS_BY_LABEL';
export const UPDATE_CARDS_FOR_LABEL = 'UPDATE_CARDS_FOR_LABEL';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const ADD_FUNNEL = 'ADD_FUNNEL';
export const UPDATE_FUNNEL_IN_LIST = 'UPDATE_FUNNEL_IN_LIST';
export const REMOVE_FUNNEL_FROM_LIST = 'REMOVE_FUNNEL_FROM_LIST';
export const MOVE_CARD = 'MOVE_CARD'; // Para atualização otimista da UI 

// Tipos para as actions e mutations do módulo Kanban

export const FETCH_FUNNELS = 'FETCH_FUNNELS';
export const FETCH_AVAILABLE_LABELS = 'FETCH_AVAILABLE_LABELS';
export const FETCH_CARDS = 'FETCH_CARDS';
export const CREATE_FUNNEL = 'CREATE_FUNNEL';
export const UPDATE_FUNNEL = 'UPDATE_FUNNEL';
export const DELETE_FUNNEL = 'DELETE_FUNNEL';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

// Novo tipo para atualizar dados de um card específico
export const UPDATE_CARD_DATA = 'UPDATE_CARD_DATA';
export const UPDATE_CARD_DATA_REACTIVE = 'UPDATE_CARD_DATA_REACTIVE'; 